import { computed } from 'vue'

export default slots => {
  const text = computed(() => {
    const defaultSlots = slots.default()
    return String((defaultSlots && defaultSlots[0].children) || '').trim()
  })
  return { text }
}
